import { Badge, FormInstance, Spin, Upload, UploadProps } from "antd";
import React, { useEffect, useState } from "react";
import { AiFillCamera } from "react-icons/ai";
import { Colors } from "../../../utilities/colors";
import { createFormData } from "../../../utilities/formData";
import { UploadService } from "../../services/upload";
import { HttpStatusCode } from "axios";

type PropsType = {
  variant?: "picture-card" | "picture" | "picture-circle";
  form?: FormInstance;
  name: string;
};

const initialValue = {
  label: "",
  value: "",
  url: "",
};

export const DynamicUploadImage = ({
  variant = "picture-circle",
  form,
  name,
}: PropsType) => {
  const [isLoading, setIsLoading] = useState(false);
  const [percent, setPercent] = React.useState(-50);

  const [initialState, setInitialState] = useState<any>(
    form?.getFieldValue(name) ?? initialValue
  );

  useEffect(() => {
    setInitialState(form?.getFieldValue(name));
  }, [form?.getFieldValue(name)]);

  useEffect(() => {
    setPercent(20);
    if (isLoading) {
      setPercent((v) => v + 50);
    }
  }, [isLoading]);

  const handleChange: UploadProps["onChange"] = ({ file }) => {
    handleUploadTheFile({ file });
  };

  const handleUploadTheFile = async (e: any) => {
    try {
      setIsLoading(true);
      const res = await UploadService.uploadImage(createFormData(e));
      if (
        res?.status === HttpStatusCode.Created ||
        res?.status === HttpStatusCode.Ok
      ) {
        setPercent(80);
        const formated = {
          label: res?.data?.basename,
          value: res?.data?.["@id"],
          url: `${res?.data?.contentUrl}`,
        };

        setInitialState(formated);
        if (form && name) {
          form && form.setFieldValue(name, formated);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setPercent(100);
      setTimeout(() => {
        setIsLoading(false);
      }, 500);
    }
  };

  const uploadButton = (
    <button style={{ border: 0, background: "none" }} type="button">
      {isLoading ? (
        <Spin percent={percent} />
      ) : (
        <AiFillCamera size={32} color={Colors.white} />
      )}
    </button>
  );

  return (
    <div className={`upload_image`}>
      <Upload
        name="avatar"
        listType={variant}
        className="avatar-uploader"
        showUploadList={false}
        beforeUpload={() => false}
        onChange={handleChange}
      >
        {initialState && !isLoading ? (
          <img
            src={`${initialState.url}`}
            alt="avatar"
            style={{
              width: "100%",
              borderRadius: "50%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        ) : (
          uploadButton
        )}
      </Upload>
    </div>
  );
};
